import type { RouteObject } from "react-router";

import { ErrorPage } from "@/components/Error/ErrorPage";
import { RequireAuth } from "@/components/Routing/RequireAuth";

import { canListPlatformGroups, canManagePlatformGroups } from "./permissions";
import { platformGroupsRoutes } from "./routes";

export const platformGroupsRoute = [
  {
    path: platformGroupsRoutes.list,
    lazy: async () => {
      const { ListPlatformGroupsPage } = await import("./pages/list/ListPlatformGroupsPage");

      return {
        element: (
          <RequireAuth permission={canListPlatformGroups}>
            <ListPlatformGroupsPage />
          </RequireAuth>
        ),
      };
    },
  },
  {
    path: platformGroupsRoutes.create,
    lazy: async () => {
      const { CreatePlatformGroupPage } = await import("./pages/create-or-edit/CreatePlatformGroupPage");

      return {
        element: (
          <RequireAuth permission={canManagePlatformGroups}>
            <CreatePlatformGroupPage />
          </RequireAuth>
        ),
      };
    },
  },
  {
    path: platformGroupsRoutes.edit,
    lazy: async () => {
      const { EditPlatformGroupPage } = await import("./pages/create-or-edit/EditPlatformGroupPage");

      return {
        element: (
          <RequireAuth permission={canManagePlatformGroups}>
            <EditPlatformGroupPage />
          </RequireAuth>
        ),
      };
    },
  },
  { path: "*", element: <ErrorPage status={404} /> },
] satisfies RouteObject[];
